import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "app-wrapper" }
const _hoisted_2 = { class: "emq-table-footer" }

import { getFirmwareList } from '@/api/evses'

import { Refresh } from '@element-plus/icons-vue'
import CommonPagination from '@/components/commonPagination.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import { pick } from 'lodash'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { dateFormat } from '@/common/tools'


import { defineComponent, ref, onMounted, defineProps, watch } from 'vue'

const __default__ = defineComponent({
  name: 'EvseFirmwares',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelID: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props

const { t, tl } = useI18nTl('Evses')



const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})

const { enableSelects, evseStateSelects } = useProtocolEnums()
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext({
  limit: 3,
})
const { updateParams } = usePaginationRemember('')

const loadDatas = async (_params = {}) => {
  lockTable.value = true
  const sendParams = {
    ...params.value,
    pageReq: {
      ...pageParams.value,
      ..._params,
    },
    modelID: props.modelID,
  }
  if (sendParams.modelID === '') {
    sendParams.modelID = '0'
  }

  try {
    const { list = [], pageReply = {} } = await getFirmwareList(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    tableData.value = list
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}

watch(
  () => props.modelID,
  (val) => {
    console.log('modelID', val)
    loadDatas()
  },
  { immediate: true },
)

onMounted(() => {
  loadDatas()
})

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_row, { gutter: 20 }, {
    default: _withCtx(() => [
      _createVNode(_component_el_col, { span: 18 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: props.modelID != '' ? _unref(tl)('firmwaresByModel') : _unref(tl)('firmwarelist')
          }, null, 8, ["label"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_col, { span: 6 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            icon: _unref(Refresh),
            onClick: loadDatas
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
            ]),
            _: 1
          }, 8, ["icon"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_col, { span: 24 }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: tableData.value,
              ref_key: "TableCom",
              ref: TableCom,
              "row-key": "evseSn"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "version",
                  "min-width": "30",
                  label: _ctx.$t('Evses.version'),
                  show: "false"
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  prop: "upgradeUrl",
                  "min-width": "120",
                  label: _ctx.$t('Evses.firmwareAddress')
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  prop: "updatedAt",
                  "min-width": "50",
                  label: _ctx.$t('Base.updatedAt')
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(_unref(dateFormat)(Number(row.createdAt) * 1000)), 1)
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["data"])), [
              [
                _directive_loading,
                lockTable.value,
                void 0,
                { lock: true }
              ]
            ]),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(CommonPagination, {
                metaData: _unref(pageMeta),
                "onUpdate:metaData": _cache[0] || (_cache[0] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
                onLoadPage: loadDatas
              }, null, 8, ["metaData"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})